export default __webpack_public_path__ + "static/media/section3-img3.9600f4e5.png";